import { PieChart } from '@/common/dashboard/charts/PieChart';
import { Mode } from '@/common/entityFramework/enumerations/Mode';
import { useNavState } from '@/common/navState/NavStateContext';
import { useRsrc } from '@/common/rsrc/RsrcContext';
import { ExprUtils } from '@/common/utils/ExprUtils';
import { useEffect, useState } from 'react';

export const McdInvProgressChart = ({ formValues, endDateToStartDate, idToMcdInvOrigin, isCld = false }) => {

  const { invPeriodId, stateIds, ctrtIds, checkRunDates, mcdInvOriginIds } = formValues;

  const { navigateTo } = useNavState();

  const rsrc = useRsrc();
  const [data, setData] = useState();


  useEffect(() => {
    if (!invPeriodId) return;

    const endDate = Math.max(...checkRunDates);
    const minEndDate = Math.min(...checkRunDates);
    const startDate = endDateToStartDate[minEndDate];
    const reqParam = {
      periodId: invPeriodId,
      stateIds,
      ctrtIds,
      startDate,
      endDate,
      mcdInvOriginNames: mcdInvOriginIds.map(id => idToMcdInvOrigin[id]), // Filter out any ids that don't have a corresponding name in the map
      isCld
    };

    rsrc.data('sc', 'MCD_INV_PROGRESS_CHART_DATA_PLUGIN', reqParam).then(data => {
      setData(data);
    });
  }, [invPeriodId, stateIds, ctrtIds, checkRunDates, mcdInvOriginIds, isCld]);

  const navigateToInvList = (dataPoint) => {

    const invStatus = dataPoint.invStatus;
    const invStatusField = isCld ? 'cldStatus' : 'sumStatus';
    let expr = ExprUtils.whereParams(invStatusField, invStatus);

    if (invPeriodId) {
      expr = ExprUtils.and(expr, ExprUtils.whereParams('invPeriodId', invPeriodId));
    }

    if (stateIds.length > 0) {
      expr = ExprUtils.and(expr, ExprUtils.setExpr('stateId', stateIds));
    }

    if (ctrtIds.length > 0) {
      expr = ExprUtils.and(expr, ExprUtils.setExpr('ctrtId', ctrtIds));
    }

    const endDate = Math.max(...checkRunDates);
    const minEndDate = Math.min(...checkRunDates);
    const startDate = endDateToStartDate[minEndDate];
    if (startDate && endDate) {
      expr = ExprUtils.and(expr, ExprUtils.effectiveDateClause('dueDate', startDate, endDate));
    }
    const selectedMcdOriginNames = mcdInvOriginIds.map(id => idToMcdInvOrigin[id]);
    if (selectedMcdOriginNames.length > 0) {
      expr = ExprUtils.and(expr, ExprUtils.setExpr('mcdInvOrigin', selectedMcdOriginNames));
    }

    const navState = {
      mode: Mode.LIST,
      expr: expr,
    };

    navigateTo('sc/mcd-inv', navState);
  };


  if (!data || data.length === 0) return;

  return (
    <PieChart
      data={data}
      onClick={(dataPoint) => navigateToInvList(dataPoint)}
    />
  );
};
